import Axios from 'axios'

let _BASE = '//api.afa.ai'
if (process.env.NODE_ENV === 'development') {
  _BASE = 'http://192.168.49.1:5005'
}

export default Axios.create({
  baseURL: _BASE,
  timeout: 10000,
  withCredentials: true,
  headers: {
    EasyToken: '8d37fda0106f49e4059239421540eaf4',
    UserId: '21546781',
    Timestamp: '98109283'
  }
})
